import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; // 実際のエンドポイントに変更する

const config = {
  timeout: 30000,
  method: null,
  url: '',
  data: null,
  withCredentials: true,
};


export default {

  getCard: async (cardId, authUserId, sessionKey) => {

    // 必要なデータが存在しない場合はエラーを返す
    if (!authUserId || !sessionKey) {
      console.log('authInfo または sessionKey が見つかりません');
    }

    config.url = baseUrl + '/api/sidecard/get';
    config.method = 'POST';
    config.data = {
      cardId, authInfo: {
        authUserId,
        sessionKey
      }
    };

    return axios.request(config)
      .then((res) => {
        if (res.data) {
          return res.data;
        } else {
          throw new Error(res.data.message || 'エラーが起きた');
        }
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },

  updateValue: async (authUserId, sessionKey, newDataValues, fileList, userInputTextBox) => {
    config.url = baseUrl + '/api/value/update';
    config.method = 'POST';
    const staffName = localStorage.getItem('staffName');
    const formData = new FormData();
    config.data = formData;

    formData.append("authUserId", authUserId);
    formData.append("sessionKey", sessionKey);
    formData.append("newDataValues", JSON.stringify(newDataValues));
    formData.append("userInputTextBox", JSON.stringify(userInputTextBox));
    formData.append("staffName", staffName);
    if(fileList && Object.keys(fileList).length > 0){
    // 複数のファイル追加
    fileList.forEach((file) => {
      formData.append("file", file);
    });
    }

    return axios.request(config)
      .then((res) => res)
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },
  savePassword: (authUserId, sessionKey, staffId, password) => {

    config.url = baseUrl + '/api/password/save';
    config.method = 'POST';
    config.data = {
      authInfo: { authUserId, sessionKey, }, staffId, password
    };

    return axios
      .request(config)
      .then((res) => res)
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },

  downloadFile: (valueId, fileName, authUserId, sessionKey) => {
    const configFile = {
      timeout: 30000,
      method: null,
      url: '',
      data: null,
      withCredentials: true,
    };

    configFile.url = baseUrl + '/api/download/file';
    configFile.method = 'POST';
    configFile.data = { valueId, fileName, authInfo: { authUserId, sessionKey } };
    configFile.responseType = 'blob';

    return axios
      .request(configFile)
      .then((response) => {
        return response
      })
      .catch((error) => {
        let errorMessage = '';
        if (error.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + error.message;
        } else if (error.response) {
          errorMessage = error.response.data.msg || 'エラーが発生しました';
        } else {
          errorMessage = error.message;
        }
        throw new Error(errorMessage);
      });
  },

  deleteFile: (authUserId, sessionKey, valueId, deleteTargetName, staffName) => {
    config.url = baseUrl + '/api/value/fileDelete';
    config.method = 'POST';
    config.data = {authInfo: { authUserId, sessionKey }, valueId, deleteTargetName, staffName };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },


  addValue: (propertyId, dataValue, authUserId, sessionKey, staffName) => {
    config.url = baseUrl + '/api/value/add';
    config.method = 'POST';
    config.data = { propertyId, dataValue, authInfo: { authUserId, sessionKey }, staffName };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },
  updateCard: (cardId, newValue, authUserId, sessionKey, staffName) => {
    config.url = baseUrl + '/api/card/update';
    config.method = 'POST';
    config.data = { cardId, newValue, authInfo: { authUserId, sessionKey }, staffName };

    return axios.request(config)
      .then((res) => {
        if (res.data) {
          return res.data;
        } else {
          throw new Error(res.data.message || 'エラーが発生しました');
        }
      })
  },

  addStatus: (tableId, dataValue, staffName, authUserId, sessionKey) => {
    config.url = baseUrl + '/api/status/add';
    config.method = 'POST';
    config.data = { tableId, dataValue, staffName, authInfo: { authUserId, sessionKey }, };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        console.error(errorMessage);  // エラーメッセージをコンソールで確認
        throw new Error(errorMessage);
      });
  },

  deleteUserInputText: (userInputTextTrashCan, staffName) => {
    config.url = baseUrl + '/api/text/delete';
    config.method = 'POST';
    config.data = {staffName, userInputTextTrashCan };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },

};
